<template>
  <div id="app" class="fillcontain">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
	@import './style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue